import React from "react";

import { NextStepsPreview } from "./NextStepsPreview";
import { ResearchFoundationSection } from "./ResearchFoundationSection";

import type {
  ExperimentFormData,
  ValidationErrors,
} from "../../types/experiment.types";

type ResearchFieldStatus = "complete" | "incomplete";

interface ExperimentResearchFormProps {
  experimentData: ExperimentFormData;
  setExperimentData: React.Dispatch<React.SetStateAction<ExperimentFormData>>;
  errors: ValidationErrors & Record<string, string>;
  validateField: (fieldName: string, value: string) => boolean;
  getFieldStatus: (value: string) => ResearchFieldStatus;
  onFieldHelp?: (fieldType: string) => void;
  hideHeader?: boolean;
}

export const ExperimentResearchForm: React.FC<ExperimentResearchFormProps> = ({
  experimentData,
  setExperimentData,
  errors,
  validateField,
  getFieldStatus,
  onFieldHelp,
}) => {
  return (
    <div className="flex flex-1 flex-col">
      <div className="flex-1 space-y-24">
        <div
          className="space-y-8"
          data-commentable
          data-component-id="research-foundation-section"
        >
          <ResearchFoundationSection
            experimentData={experimentData}
            setExperimentData={setExperimentData}
            errors={errors}
            validateField={validateField}
            getFieldStatus={getFieldStatus}
            onFieldHelp={onFieldHelp}
          />
        </div>

        <div
          className="mt-16 border-t border-white/10 pt-8"
          data-commentable
          data-component-id="next-steps-preview"
        >
          <NextStepsPreview currentStep={2} />
        </div>
      </div>
    </div>
  );
};
